/**
 * EAA-1736: Audio extension with a React NodeView for the editor.
 * Re-exports the base Audio with addNodeView so audio supports the shared media
 * layout + context menu. The base Audio (renderHTML) is still what the static
 * viewer uses via generateHTML, so playback output is unchanged.
 */

import { Audio } from './tiptap-audio';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { AudioView } from '../components/content/rich-text/AudioView';

export const AudioWithView = Audio.extend({
    addNodeView() {
        return ReactNodeViewRenderer(AudioView);
    },
});

export default AudioWithView;
